import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentToolEntity } from './conversation-agent-tool.entity';

@Entity('_conversation_tool')
@Index('ft_tool_search', ['name', 'description', 'type'], { fulltext: true })
export class ConversationToolEntity extends BaseEntity {
	@Column({ name: 'type', type: 'varchar', length: 50, nullable: false })
	@Index('idx_tool_type')
	public type!: string;

	@Column({ name: 'name', type: 'varchar', length: 100, nullable: false })
	public name!: string;

	@Column({ name: 'description', type: 'text', nullable: true })
	public description?: string;

	@Column({ name: 'metadata', type: 'json', nullable: true })
	public metadata?: any;

	@Column({ name: 'is_default', type: 'tinyint', width: 1, default: 0 })
	@Index('idx_tool_is_default')
	public isDefault!: boolean;

	// Relationships
	@OneToMany(() => ConversationAgentToolEntity, (agentTool) => agentTool.tool)
	public agentTools?: ConversationAgentToolEntity[];

	// Indexes
	@Index('idx_tool_owner')
	public static ownerIndex: string = '_owner_userId';

	@Index('idx_tool_created')
	public static createdIndex: string = '_created_date';
}
